const IMAGE_SIZES = {
  small: 40,
  medium: 350,
  large: 550,
};

export default IMAGE_SIZES;
